import * as consts from 'consts/consts';
import { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Page from 'views/Layout/Pages/Page';
import { SURVEY_EDITOR_TAB_PARAM } from '../consts';
import CustomSurveyReportBuilder from './CustomSurveyReportBuilder';

interface RouteParams {
  id: string;
  reportId: string;
}

// Full-page editor for a single custom-survey report, on its own route so
// the reports tab stays a plain list and an in-progress report is linkable.
const CustomSurveyReportEditorPage: FC = () => {
  const { id, reportId } = useParams<RouteParams>();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const location = useLocation();

  const backToReports = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.set(SURVEY_EDITOR_TAB_PARAM, 'reports');
    history.push({
      pathname: consts
        .ADMINISTRATION_CUSTOM_SURVEYS_EDITOR(formatMessage)
        .path.replace(':id', id),
      search: params.toString(),
    });
  }, [history, formatMessage, id, location.search]);

  return (
    <Page>
      <CustomSurveyReportBuilder
        reportId={Number(reportId)}
        onClose={backToReports}
      />
    </Page>
  );
};

export default CustomSurveyReportEditorPage;
